<atom-icon-button
    icon="times"
    [size]="size"
    [btnClass]="btnClass"
    [cySelector]="cySelector"
    (onClick)="hasClicked($event)"
></atom-icon-button>
